import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { ResourcesHeader, Tabs, Tab } from '@unite-us/app-components';
import { connect } from 'react-redux';
import { useSelectedPrograms } from '@unite-us/app-search';
import { updateGlobalState } from 'actions/Global/globalActions';

import './NetworkSubHeader.scss';

function NetworkSubHeader({
  router,
  isShoppingCartOpen,
  setIsShoppingCartOpen,
  setShoppingCartDrawerRef,
}) {
  useEffect(() => {
    setIsShoppingCartOpen(false);
  }, []);

  const { selectedPrograms } = useSelectedPrograms();

  const tabsValue = useMemo(() => {
    const pathname = router.location.pathname;
    const segments = pathname.split('/');
    const last = segments[segments.length - 1];
    return ['browse', 'orgs', 'users'].includes(last) ? last : 'browse';
  }, [router.location.pathname]);

  const handleChange = (value) => {
    router.push(`/browse-resources/${value === 'browse' ? '' : value}`);
  };

  const onSelectedProgramsClick = () => (event) => {
    setShoppingCartDrawerRef(event.currentTarget);
    setIsShoppingCartOpen(!isShoppingCartOpen);
  };

  return (
    <div className="network-subheader">
      <ResourcesHeader
        showAddedResourcesBtn={tabsValue === 'browse'}
        selectedProgramsAmount={selectedPrograms.length}
        onSelectedProgramsClick={onSelectedProgramsClick}
      />
      <div className="network-subheader__tabs">
        <Tabs
          id="network-subheader__profile network-profile-tabs"
          className="network-profile-tabs"
          value={tabsValue}
          onChange={handleChange}
        >
          <Tab
            id="browse-map-tab"
            className="bg-white text-brand-blue hover:bg-medium-fill-blue px-4 border-b"
            style={{ borderBottomStyle: 'solid' }}
            value="browse"
            label="Browse Resources"
            onChange={() => {}}
          />
          <Tab
            id="org-tab"
            className="bg-white text-brand-blue hover:bg-medium-fill-blue px-4 border-b"
            style={{ borderBottomStyle: 'solid' }}
            value="orgs"
            label="Organizations"
            onChange={() => {}}
          />
          <Tab
            id="users-tab"
            className="bg-white text-brand-blue hover:bg-medium-fill-blue px-4 border-b"
            style={{ borderBottomStyle: 'solid' }}
            value="users"
            label="Users"
            onChange={() => {}}
          />
        </Tabs>
      </div>
    </div>
  );
}

NetworkSubHeader.propTypes = {
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
  isShoppingCartOpen: PropTypes.bool.isRequired,
  setIsShoppingCartOpen: PropTypes.func.isRequired,
  setShoppingCartDrawerRef: PropTypes.func,
};

NetworkSubHeader.defaultProps = {
  setShoppingCartDrawerRef: () => {},
};

function mapStateToProps(state) {
  return {
    isShoppingCartOpen: state.globalState.isShoppingCartOpen,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setIsShoppingCartOpen: (isOpen) => dispatch(updateGlobalState({ isShoppingCartOpen: isOpen })),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NetworkSubHeader),
);
